import { useTranslation } from 'react-i18next';

import type { TextSegment } from '@/lib/htmlTextExtractor';

interface ContentEditorProps {
  segments: TextSegment[];
  editedContents: Record<number, string>;
  onChange: (segmentId: number, content: string) => void;
}

export function ContentEditor({ segments, editedContents, onChange }: ContentEditorProps) {
  const { t } = useTranslation();

  if (segments.length === 0) {
    return (
      <div className='text-sm text-gray-400 text-center py-8'>
        {t('notificationTemplates.editor.noEditableContent')}
      </div>
    );
  }

  return (
    <div className='space-y-4'>
      {segments.map((segment) => {
        const currentContent = editedContents[segment.id] ?? segment.displayText;
        const isHeading = /^h/i.test(segment.tagName);

        return (
          <div key={segment.id}>
            <label className='block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1'>
              {segment.label}
            </label>
            {isHeading ? (
              <input
                type='text'
                value={currentContent}
                onChange={(e) => onChange(segment.id, e.target.value)}
                className='w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none'
              />
            ) : (
              <textarea
                value={currentContent}
                onChange={(e) => onChange(segment.id, e.target.value)}
                rows={Math.min(Math.max(currentContent.split('\n').length + 1, 2), 6)}
                className='w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none resize-y'
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
